<div class="form-control form-control-sm d-flex flex-wrap align-items-center gap-2" [class.disabled]="disabled" [class.bg-light]="disabled">

    <span *ngFor="let tag of tags; let i = index" class="badge bg-primary">
        {{ tag }}
        @if(!disabled) {
        <button type="button" class="btn-close btn-close-white ms-1" aria-label="Remove Tag" (click)="removeTag(i)" [disabled]="disabled">
        </button>
        }
    </span>
@if(!disabled) {
    <input type="text" class="form-control form-control-sm border-0" placeholder="Ajouter tag" [(ngModel)]="newTagValue"
           (keydown.enter)="addTag(); $event.preventDefault()" (blur)="handleBlur()" [disabled]="disabled">
}
</div>